
export const NOTIFICATION_ACTION_TYPES = {
    SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
    SET_FILTERED_NOTIFICATIONS: 'SET_FILTERED_NOTIFICATIONS',
    CLEAR_NOTIFICATIONS_STATE: 'CLEAR_NOTIFICATIONS_STATE',
    SET_UNREAD_NOTIFICATIONS: 'SET_UNREAD_NOTIFICATIONS',
    UPDATE_NOTIFICATIONS_PAGINATION: 'UPDATE_NOTIFICATIONS_PAGINATION'
};
